import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
Vue.prototype.$axios = axios
import './plugins/element.js'
// import 'element-ui/lib/theme-chalk/index.css'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './assets/iconfont/iconfont.css'
// 引入全局样式
import './assets/css/global.css'
// 引入字体图标
import 'font-awesome/css/font-awesome.min.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'vxe-pc-ui/lib/style.css'
import VxeUITable from 'vxe-table'
import 'vxe-table/lib/style.css'
import  VxeUI  from 'vxe-pc-ui'
import VxeUIPluginExportXLSX from '@vxe-ui/plugin-export-xlsx'
import ExcelJS from 'exceljs'
import api from '@/api';
// 创建 Event Bus（全局定义）
import { EventBus } from './event-bus';
// 复制插件
import VueClipBoard from 'vue-clipboard2';

Vue.prototype.$eventBus = EventBus; // 挂载到 Vue 原型

Vue.prototype.$api = api;
VxeUI.use(VxeUIPluginExportXLSX, {
  ExcelJS
})
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.use(VxeUI)
Vue.use(VxeUITable)
Vue.use(ElementUI);
Vue.use(VueClipBoard);


import AFTableColumn from 'af-table-column'
const fontRate = {
    CHAR_RATE: 1.1, // 汉字比率
    NUM_RATE: 0.65, // 数字
    OTHER_RATE:10 // 除汉字和数字以外的字符的比率
}
const fontSize =20
// 注册组件
Vue.use(AFTableColumn, { fontRate, fontSize })
import './mixins/draggable.js'

import i18n from './i18n/index.js';

import copy from './directives/copy.js'; 
import XEUtils from 'xe-utils'
import VXEUtils from 'vxe-utils'
 
// mounts 可以设置['cookie', 'browse', 'locat']
Vue.use(VXEUtils, XEUtils, {mounts: ['cookie']})

// 注册全局指令
Vue.directive('copy', copy);
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')


// loading
import loadingObj from '@/utils/globalLoading'
Vue.prototype.loadingObj = loadingObj

Vue.config.productionTip = false

// Vue.use(ElementUI)
// new Vue({
//   router,
//   store,  //store:store 和router一样，将创建的Vuex实例挂载到这个vue实例中
//   render: h => h(App)
// }).$mount('#app')


